import { Meta } from "@angular/platform-browser";
import { environment } from "src/environments/environment";

export function initIndexing(meta: Meta): () => Promise<void> {
  return async () => {
    const isProduction = environment.production;

    meta.removeTag('name="robots"');
    meta.addTag({
      name: 'robots',
      content: isProduction ? 'index, follow' : 'noindex, nofollow',
    });
  };
}
